import { render, staticRenderFns } from "./EmployeeCreate.vue?vue&type=template&id=bbf502a8"
import script from "../../controllers/employee/employee-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/employee/employee-create.js?vue&type=script&lang=js&external"
import style0 from "./EmployeeCreate.vue?vue&type=style&index=0&id=bbf502a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports